import React from "react";

/**
 * Mono-spaced uppercase label — the brand's smallest type unit.
 * Used as eyebrow text, section meta and breadcrumb segments.
 */
export const MonoLabel = ({
    children,
    size = 11,
    tone = "default",
    as: Tag = "span",
    className,
    style,
    ...rest
}) => {
    const color =
        tone === "default"
            ? "var(--on-ink-soft)"
            : tone === "mute"
              ? "var(--on-ink-mute)"
              : tone === "faint"
                ? "var(--on-ink-faint)"
                : tone === "ink"
                  ? "var(--on-ink)"
                  : tone === "signal"
                    ? "var(--signal)"
                    : tone;

    return (
        <Tag
            className={className}
            style={{
                fontFamily: "var(--font-mono)",
                fontSize: size,
                letterSpacing: "0.28em",
                textTransform: "uppercase",
                color,
                ...style,
            }}
            {...rest}
        >
            {children}
        </Tag>
    );
};

export default MonoLabel;
